import { useEffect, useState } from 'react';
import { Chat, Channel, ChannelHeader, Thread, Window, MessageList, MessageInput } from 'stream-chat-react';
import { StreamChat } from 'stream-chat';
import 'stream-chat-react/dist/css/index.css';
import { setCookie, getCookie } from './helper';
import './main.scss';

export const App = () => {
     const channelName = 'KRASWebinar2026';
     const campaign = 'KRAS Webinar 2026 RSVP'; 
     const key = 'e9s3wgh95fug';
     const cookie = 'Kras26';
     const imageAvatar =
          'https://0b9aafecab229788ebf1-90f622f94aeb4d165ef7469777c28f31.ssl.cf2.rackcdn.com/pancan-chat/02/2021/pancan-chat-avatar.png';

     const [chatClient, setChatClient] = useState(null);
     const [channel, setChannel] = useState(undefined);
     const [valid, setValid] = useState(false);
     const [annonymous, setAnnonymous] = useState(true);
     const [user, setUser] = useState(null) as any;
     const [username, setUsername] = useState(null);
     const [localFullName, setLocalfullname] = useState(null);
     const [localEmail, setLocalEmail] = useState(null);

     //Methods
     const getTheUserInfoByEmail = async () => { 
          const urlParams = new URLSearchParams(window.location.search);
          const email = urlParams.get('email') || false;
          if (!email) {
               setUser(null);
               setAnnonymous(true);
               return;
          }
          if(user) return; // There is a user so kill this process
          
          const userByEmail: any = await fetch(
               `https://core.pancan.org/api/campaign/logRSVP/?key=5994766c58613900370b6153&email=${email}&campaign=${campaign}`
          )
               .then((json: any) => json.json())
               .then((user: any) => user)
               .catch((error: Error) => {console.log(`Error ocurred fetching user by email ${error}`); return false;});

          if (!userByEmail) {
               setUser(null);
               setAnnonymous(true);
               return;
          }
          setUser(userByEmail);
          return setAnnonymous(false);
     };

     const connectUser = async(token: string, user: any) => {
          const chat: any = StreamChat.getInstance(key);
          await chat.connectUser(user, token);
          const ch = chat.channel('messaging', channelName, { name: channelName });
          setChatClient(chat);
          setChannel(ch);
     };

     const generateClientToken = async () => {
          if (!username || username === '') return;
          if (!user && (localEmail === '' || localFullName === '')) return;

          // Generate first time token
          const token = await fetch(`https://core.pancan.org/api/campaign/userChat?key=5994766c58613900370b6153&username=${username}`, {mode: 'cors'})
               .then((json: any) => json.json())
               .then((result) => result)
               .catch((error: Error) => {console.log('error', error); return false; });
          if (!token || !token.success) return;
          
          const userObject = user
               ? {
                      id: username,
                      full_name: user.name,
                      email: user.email,
                      name: username,
                      image: imageAvatar,
                      role: 'user'
                 }
               : {
                      id: username,
                      name: username,
                      full_name: localFullName,
                      email: localEmail,
                      image: imageAvatar,
                      role: 'user'
                 };
          setValid(true);
          connectUser(token.data, userObject);
          setCookie(JSON.stringify({ token: token.data, user: userObject }), cookie);
     };

     const inputChangeHandler = (e: any) => {
          const { value } = e.target;
          const clean_str = value.replace(/[\W_]+/g, '_');
          setUsername(clean_str);
     };

     const inputOnChange = (e: any) => {
          const { name, value } = e.target;
          if (name === 'localFullName') return setLocalfullname(value);
          return setLocalEmail(value);
     };

     const sessionCheck = async() => {
          const cookieData:any = await getCookie(cookie); // Collect the user if it exists from the browser
          if(!cookieData || cookieData === '') return getTheUserInfoByEmail(); // No webinar cookie stored, get user by email
          const cookieValue: any = JSON.parse(cookieData);
          if(!cookieValue.token && cookieValue.token === '') return setValid(false); // check for token if not invalid
          if(!cookieValue.user && cookieValue.user === '') return setValid(false); // check for user if not invalid          
          setValid(true);
          setUsername(cookieValue.username);
          connectUser(cookieValue.token, cookieValue.user);
     }

     useEffect(() => {         
          sessionCheck(); // Check for the user
     });

     // Track all the other stuff here
     useEffect(() => {}, [chatClient, channel, valid, annonymous, user, username, localFullName, localEmail]);

     return (
          <div className="chat-app">
               {!valid ? (
                    <div className="initbox">
                         <h2 className="section-box-title over-solid">Live Chat</h2>
                         <span style={{ marginBottom: '10px', fontStyle: 'italic', fontSize: 12, color: '#ff0000', display: 'table' }}>* Required field</span>
                         <div className="form-group">
                              <label htmlFor="username" style={{marginBottom: '10px', lineHeight: '1.2'}}>
                                   Enter your display name below to join the public chat and connect with other members of the PanCAN community.  For personalized, one-to-one support, contact PanCAN Patient Services at 1-877-2-PANCAN or <a href="mailto:patientservices@pancan.org">patientservices@pancan.org</a>.
                              </label>
                              <input
                                   className="form-control"
                                   placeholder="*Desired Display Name"
                                   type="text"
                                   name="username"
                                   onChange={inputChangeHandler}
                              />
                         </div>
                         {annonymous ? (
                              <div>
                                   <div className="form-group">
                                        <label htmlFor="username" style={{marginBottom: '10px'}}>Name</label>
                                        <input
                                             className="form-control"
                                             placeholder="*Full Name"
                                             type="text"
                                             name="localFullName"
                                             onChange={inputOnChange}
                                        />
                                   </div>
                                   <div className="form-group">
                                        <label htmlFor="username" style={{marginBottom: '10px'}}>Email</label>
                                        <input
                                             className="form-control"
                                             placeholder="*Email"
                                             type="email"
                                             name="localEmail"
                                             onChange={inputOnChange}
                                        />
                                   </div>
                              </div>
                         ) : null}
                         <button className="btn general-button" onClick={generateClientToken}>
                              Join the Chat
                         </button>
                    </div>
               ) : (
                    <div className="chat-box">
                         {chatClient ? (
                              <Chat client={chatClient} theme={'messaging light'}>
                                   <Channel channel={channel}>
                                        <Window>
                                             <ChannelHeader title={'Live Chat'} />
                                             <MessageList messageActions={['delete', 'flag', 'mute', 'react']} hideDeletedMessages={true} />
                                             <MessageInput />
                                        </Window>
                                        <Thread />
                                   </Channel>
                              </Chat>
                         ) : null}
                    </div>
               )}
          </div>
     );
};
